import { palettes } from "../../themes/palletes";

export const emptyCont = {
  height: "200px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const customStyledTableRow = {
  backgroundColor: "white",
  height: "100px",
};

export const productsCont = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  position: "relative",
  height: "40px",
};

export const productsOverflow = {
  width: "30px",
  height: "20px",
  border: "1px solid white",
  backgroundColor: "white",
  borderRadius: "10px",
  position: "absolute",
  left: `${45}%`,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: "text.main",
  fontSize: "10px",
};

export const productItemCont = {
  width: "20px",
  height: "20px",
  overflow: "hidden",
  backgroundColor: "white",
  borderRadius: "50%",
  position: "absolute",
};

export const productPhotoUrlFallback = {
  width: "100%",
  height: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: "white",
  fontSize: "calc(100% - 5px)",
  fontWeight: "bold",
  textTransform: "uppercase",
};

export const dialogCont = {
  width: "700px",
  height: "550px",
  borderRadius: "16px",
};

export const dialogBox = {
  position: "relative",
  width: "100%",
  height: "80%",
  borderBottomLeftRadius: 6,
  borderBottomRightRadius: 6,
  overflow: "hidden",
};

export const dialogContentBox = {
  mt: 1,
  paddingLeft: 10,
  paddingRight: 10,
  paddingTop: 3,
};

export const dialogSlider = {
  height: 12,
  "& .MuiSlider-track": {
    backgroundColor: "#FF5F47",
    border: "red",
  },
  "& .MuiSlider-thumb": {
    backgroundColor: "#FF5F47",
  },
  "& .MuiSlider-rail": {
    backgroundColor: "#d0d0d0",
  },
};

export const dialogBoxButtons = {
  display: "flex",
  justifyContent: "flex-end",
  mt: 2,
  paddingRight: 5,
  mb: 2
};

export const dialogSaveButton = {
  backgroundColor: "#123257", 
  borderRadius: "12px"
};

export const dialogBoxImage = {
  height: "120px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
};

export const dialogBoxImagePlaceholder = {
  width: "120px",
  height: "120px",
  borderRadius: "50%",
  backgroundColor: "#B6BFCB",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  overflow: "hidden",
};

export const dialogBoxPreviewUrl = {
  width: "100%",
  height: "100%",
  objectFit: "cover",
};

export const dialogBoxAdd = {
  position: "absolute",
  bottom: 0,
  right: 0,
  width: "36px",
  height: "36px",
  borderRadius: "50%",
  backgroundColor: "#FF5F47",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  boxShadow: 1,
  cursor: "pointer",
};

export const dialogAddPhoto = {
  fontSize: 25,
  color: "#fff",
};

export const dialogMainBox = {
  position: "relative",
  width: "120px",
  height: "120px",
};

export const userPhotoCell = (isActive: boolean) => ({
  width: "10px",
  padding: "5px",
  backgroundColor: isActive ? palettes.$backgroundHover : undefined,
  transition: "background-color 0.2s ease-in-out",
});

export const userNameCell = (isActive: boolean) => ({
  maxWidth: "120px",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  padding: "5px",
  backgroundColor: isActive ? palettes.$backgroundHover : undefined,
  transition: "background-color 0.2s ease-in-out",
});

export const userBirthdayCell = (isActive: boolean) => ({
  padding: "5px",
  backgroundColor: isActive ? palettes.$backgroundHover : undefined,
  transition: "background-color 0.2s ease-in-out",
});

export const userEmailCell = (isActive: boolean) => ({
  maxWidth: "150px",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  padding: "5px",
  backgroundColor: isActive ? palettes.$backgroundHover : undefined,
  transition: "background-color 0.2s ease-in-out",
});

export const productsCell = (isActive: boolean) => ({
  maxWidth: "30px",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  position: "relative",
  padding: "5px",
  backgroundColor: isActive ? palettes.$backgroundHover : "transparent",
  transition: "background-color 0.2s ease-in-out",
});

export const userFormCont = (isLaptopAndUp: boolean) => ({
  borderRadius: "8px",
  padding: "8px",
  minWidth: isLaptopAndUp ? "700px" : "100%",
  border: "3px solid var(--Colors-old-app-bg, rgba(242, 245, 251, 1))",
});

export const userFormGridSize = {
  mobile: 12,
  tablet: 12,
  laptop: 6,
};

export const roleBox = {
  position: { mobile: "relative", laptop: "absolute" },
  top: 0,
  right: 0,
  width: { mobile: "100%", laptop: "230px" },
};

export const dataTable = {
  main: {
    width: "100%",
    minHeight: "300px",
    position: "relative",
  },
  progressIndicatorCont: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(221, 221, 221, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 10,
  },

  emptyResult: {
    cell: {
      backgroundColor: "white",
      height: "100px",
    },
    main: {
      textAlign: "center",
      color: "#6D87AA",
      fontSize: "18px",
      fontWeight: 500,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: 1,
    },
    text: {
      fontFamily: "Poppins",
      fontWeight: 600,
      fontSize: "24px",
      color: "#A1A1A1",
      textAlign: "center",
    },
  },
};
